export default __webpack_public_path__ + "static/media/newOrderAlarm.160e8f0b.mp3";